export default __webpack_public_path__ + "static/media/pw_change_success.9ee928af.svg";